export const getConnectorId = (connector, chainType) => {
    if (!connector) {
        return '';
    }
    return 'id' in connector && connector.id
        ? connector.id
        : `${connector.name}-${chainType}`;
};
//# sourceMappingURL=getConnectorId.js.map